import { type FeatureFlags } from '../types/FeatureFlags'
import { useFeatureFlags } from './useFeatureFlags'

export function useFeatureFlagValue(flag: keyof FeatureFlags) {
  const flags = useFeatureFlags()

  return flags[flag] ?? false
}
